import { pushEvent } from '../../client/data-layer';

export function trackKWLPProductClick(keyword: string, productId: number) {
  pushEvent('keywordLandingPageProductClick', {
    keyword,
    productId,
  });
}

export function trackKWLPOfferClick(keyword: string, offerId: string) {
  pushEvent('keywordLandingPageOfferClick', {
    keyword,
    offerId,
  });
}

export function trackKWLPCategoryClick(keyword: string, categoryName: string) {
  pushEvent('keywordLandingPageCategoryClick', {
    keyword,
    categoryName,
  });
}

/**
 * Tracks all the ids of offers and products without any images.
 */
export function trackKWLPNoImages(url: string, prodAndOfferIds: string) {
  pushEvent('keywordLandingPageNoImages', {
    url,
    prodAndOfferIds,
  });
}

export function trackKWLPOffersOnlyVisited(keyword: string, pageUrl: string) {
  pushEvent('keywordLandingPageOffersOnlyVisited', {
    keyword,
    pageUrl,
  });
}

export function trackKWLPNoItems(keyword: string, pageUrl: string) {
  pushEvent('keywordLandingPageNoItems', {
    keyword,
    pageUrl,
  });
}
